export default __webpack_public_path__ + "static/media/thai-oil-logo.9125c194.svg";